import * as z from "zod/v4";
const ProfileDateRangeSchema_ = z.object({
    startDate: z.string(),
    endDate: z.string(),
});
export const ProfileDateRangeSchema = ProfileDateRangeSchema_;
//# sourceMappingURL=profile-date-range.js.map